import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "podcast-follow-btn-wrapper" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "podcast-follow-btn__label" }
const _hoisted_4 = {
  key: 0,
  class: "podcast-follow-btn__hint"
}
const _hoisted_5 = { class: "podcast-follow-btn__hint-text" }

import { PodcastFollowView } from '@/models/docs.list.podcasts.episodes'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PodcastFollowButton',
  props: {
    view: {},
    useLinkVariant: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.useLinkVariant)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["podcast-follow-btn podcast-follow-btn--link", { 'podcast-follow-btn--followed': __props.view.isFollowed }]),
          disabled: __props.view.isLoading,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.view.toggleFollow())),
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (__props.view.updateLabel($event))),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (__props.view.updateLabel($event)))
        }, _toDisplayString(__props.view.label), 43, _hoisted_2))
      : (_openBlock(), _createBlock(AppButton, {
          key: 1,
          class: "podcast-follow-btn",
          loading: __props.view.isLoading,
          primaryAlt: !__props.view.isFollowed,
          outlined: __props.view.isFollowed,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.view.toggleFollow())),
          onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (__props.view.updateLabel($event))),
          onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (__props.view.updateLabel($event)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.view.label), 1),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "podcast-follow-btn__placeholder" }, "Following", -1))
          ]),
          _: 1
        }, 8, ["loading", "primaryAlt", "outlined"])),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.view.hint)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(__props.view.hint), 1),
              _createElementVNode("button", {
                class: "podcast-follow-btn__close-hint",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (__props.view.hideHint()))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "iconfont iclose" }, null, -1)
              ]))])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})